import {FormControl, FormField} from 'platform/components';
import {Text, VStack} from 'platform/foundation';

import {i18n} from '@dms/i18n';

import {PurchasePriceRuleFormValues} from '../PurchasePriceRuleFormSchema';
import {PurchasePriceRuleFormSection} from './PurchasePriceRuleFormSection';
import {PurchasePriceRuleModifierCard} from './PurchasePriceRuleModifierCard';

interface PurchasePriceRuleModifiersSectionProps {
  control: FormControl<PurchasePriceRuleFormValues>;
  baseTestId: (suffix: string) => string;
}

export function PurchasePriceRuleModifiersSection(props: PurchasePriceRuleModifiersSectionProps) {
  return (
    <PurchasePriceRuleFormSection
      title={i18n.t('page.settings.purchasePrice.ruleEditor.modifiers.title')}
      description={i18n.t('page.settings.purchasePrice.ruleEditor.modifiers.description')}
      data-testid={props.baseTestId('modifiersSection')}
    >
      <Text size="small" color="secondary">
        {i18n.t('page.settings.purchasePrice.ruleEditor.modifiers.hint')}
      </Text>

      <VStack spacing={4}>
        <PurchasePriceRuleModifierCard
          control={props.control}
          modifier="electricVehicle"
          title={i18n.t('page.settings.purchasePrice.ruleEditor.modifiers.electricVehicle.title')}
          note={i18n.t('page.settings.purchasePrice.ruleEditor.modifiers.electricVehicle.note')}
          baseTestId={props.baseTestId}
        />

        <PurchasePriceRuleModifierCard
          control={props.control}
          modifier="highMileage"
          title={i18n.t('page.settings.purchasePrice.ruleEditor.modifiers.highMileage.title')}
          note={i18n.t('page.settings.purchasePrice.ruleEditor.modifiers.highMileage.note')}
          baseTestId={props.baseTestId}
        >
          <FormField
            control={props.control}
            name="modifiers.highMileage.threshold"
            type="integer"
            suffix={i18n.t('general.metric.km')}
            label={i18n.t('page.settings.purchasePrice.ruleEditor.modifiers.highMileage.threshold')}
            isRequired
            data-testid={props.baseTestId('highMileageThreshold')}
          />
        </PurchasePriceRuleModifierCard>

        <PurchasePriceRuleModifierCard
          control={props.control}
          modifier="higherAge"
          title={i18n.t('page.settings.purchasePrice.ruleEditor.modifiers.higherAge.title')}
          note={i18n.t('page.settings.purchasePrice.ruleEditor.modifiers.higherAge.note')}
          baseTestId={props.baseTestId}
        >
          <FormField
            control={props.control}
            name="modifiers.higherAge.threshold"
            type="integer"
            suffix={i18n.t('page.settings.purchasePrice.ruleEditor.modifiers.higherAge.unit')}
            label={i18n.t('page.settings.purchasePrice.ruleEditor.modifiers.higherAge.threshold')}
            isRequired
            data-testid={props.baseTestId('higherAgeThreshold')}
          />
        </PurchasePriceRuleModifierCard>
      </VStack>
    </PurchasePriceRuleFormSection>
  );
}
